export const STATUS = {
  bez_rezervace: { label: "Bez rezervace", bg: "#F1F5F9", border: "#CBD5E1", text: "#475569", badgeBg: "#E2E8F0", badgeText: "#334155" },
  rezervovano: { label: "Rezervováno", bg: "#EFF6FF", border: "#93C5FD", text: "#1E40AF", badgeBg: "#DBEAFE", badgeText: "#1E3A8A" },
  scheduled: { label: "Rezervováno", bg: "#EFF6FF", border: "#93C5FD", text: "#1E40AF", badgeBg: "#DBEAFE", badgeText: "#1E3A8A" },
  hotovo: { label: "Hotovo", bg: "#ECFDF5", border: "#6EE7B7", text: "#065F46", badgeBg: "#D1FAE5", badgeText: "#064E3B" },
  done: { label: "Hotovo", bg: "#ECFDF5", border: "#6EE7B7", text: "#065F46", badgeBg: "#D1FAE5", badgeText: "#064E3B" },
  nezasticen: { label: "Nezastižen", bg: "#FEF2F2", border: "#FCA5A5", text: "#991B1B", badgeBg: "#FEE2E2", badgeText: "#7F1D1D" },
  missed: { label: "Nezastižen", bg: "#FEF2F2", border: "#FCA5A5", text: "#991B1B", badgeBg: "#FEE2E2", badgeText: "#7F1D1D" },
};

export const ACTION_STATUS = {
  priprava: { label: "Příprava", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  zverejneno: { label: "Zveřejněno", cls: "bg-blue-50 text-blue-800 border-blue-300" },
  uzavreno: { label: "Uzavřeno", cls: "bg-amber-50 text-amber-800 border-amber-300" },
  dokonceno: { label: "Dokončeno", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
};

export function StatusBadge({ status }) {
  const s = STATUS[status] || STATUS.bez_rezervace;
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold border"
      style={{ background: s.badgeBg, color: s.badgeText, borderColor: s.border }}
    >
      {s.label}
    </span>
  );
}
